import { render, staticRenderFns } from "./RequestInfoDialogSplit.vue?vue&type=template&id=d78cade4&"
import script from "./RequestInfoDialogSplit.vue?vue&type=script&lang=ts&"
export * from "./RequestInfoDialogSplit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports